import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Chatbot } from "../../../assets/svg";
import styles from "./header.module.sass";

const cx = classNames.bind(styles);

const HeaderChatCta = ({ onClick }) => {
  const [showBubble, setShowBubble] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBubble(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <button type="button" className={cx("headerChatGroup")} onClick={onClick}>
      {showBubble && (
        <span className={cx("headerChatBubble")}>
          <span className={cx("headerChatLine")}>Trò chuyện với</span>
          <span className={cx("headerChatLine")}>Trợ lý tuyển dụng</span>
        </span>
      )}

      <span className={cx("chatBotAvatar")} aria-hidden="true">
        <Chatbot />
      </span>
    </button>
  );
};

export default HeaderChatCta;